export enum LoanOriginationSystemLabelsFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemLabelsFilters/setSearchInputValue',
}
